import {
  ADD_ALL_EDUCATION_INFO,
  ADD_COUNT,
  ADD_EDUCATION_INFO,
  ADD_EDU_DATA,
  ADD_TOTAL,
  RESET_EDU,
} from "./actions";

const initialState = {
  eduInfo: {
    city: "",
    campusSpecific: "",
    fee: "",
    paymentReciept: "",
    admissionLetter: "",
    degreeType: "",
    college: "",
  },
  count: 0,
  total: 0,
  cityList: [],
  campusList: [],
};

const EducationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_EDUCATION_INFO:
      let data = state.eduInfo;
      if (
        action.data.type === "city" ||
        action.data.type === "campusSpecific"
      ) {
        if (action.data.value !== "") {
          data[action.data.type] = action.data.value;
        }
      } else {
        data[action.data.type] = action.data.value;
      }
      return {
        ...state,
        eduInfo: { ...data },
      };
    case ADD_ALL_EDUCATION_INFO:
      let data2 = state.eduInfo;
      if (action.data) {
        data2 = action.data;
      }
      return {
        ...state,
        eduInfo: { ...data2 },
      };
    case ADD_COUNT:
      let data3 = state.count;
      data3 = action.data;
      return {
        ...state,
        count: data3,
      };
    case ADD_TOTAL:
      let data4 = state.total;
      data4 = action.data;
      return {
        ...state,
        total: data4,
      };
    case ADD_EDU_DATA:
      if (!state["cityList"]) {
        state = { ...state, cityList: [] };
      }
      if (!state["campusList"]) {
        state = { ...state, campusList: [] };
      }
      state[action.data[0]] = action.data[1];
      return {
        ...state,
      };
    case RESET_EDU:
      return initialState;
    default:
      return state;
  }
};
export default EducationReducer;
